import React from "react";

type CategoryHeadingProps = {
  category: string;
};
const CategoryHeading = (props: CategoryHeadingProps) => {
  return (
    <div className="border-b-2 border-neutral-800 mb-4">
      <span className="bg-neutral-800 text-white px-4 py-1 rounded-tl-sm rounded-tr-sm">
        {props?.category}
      </span>
    </div>
  );
};

export default CategoryHeading;
